const headerDataTow = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	// {
	//   prop: "StatusName",
	//   label: "状态",
	//   columnwidth: 55,
	// },
	{
		prop: "InvoiceCheckedName",
		label: "状态",
		columnwidth: 140,
	},
	{
		prop: "InvoiceNo",
		label: "发票号码",
		columnwidth: 200,
	},
	{
		prop: "SBDate",
		label: "开票日期",
		columnwidth: 110,
	},
	{
		prop: "ReturnName",
		label: "发票方向",
		columnwidth: 50,
	},
	{
		prop: "CusName",
		label: "付款方",
		columnwidth: 233,
	},
	{
		prop: "TerminalHPName",
		label: "终端医院",
		columnwidth: 230,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 232,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 150,
	}, {
		prop: "IsInvalidName",
		label: "是否作废",
		columnwidth: 150,
	}, {
		prop: "RedOffsetAmount",
		label: "被红冲金额",
		columnwidth: 150,
	}, {
		prop: "OrgInvoiceNo",
		label: "对应蓝票号",
		columnwidth: 150,
	}, {
		prop: "RedInvoiceNo",
		label: "红字发票号",
		columnwidth: 150,
	}, {
		prop: "BlueInvoiceNo",
		label: "重开蓝票号",
		columnwidth: 150,
	}, {
		prop: "RedTypeName",
		label: "红票类型",
		columnwidth: 150,
	},
	{
		prop: "VerifyCode",
		label: "发票校验码",
		columnwidth: 180,
	},
	{
		prop: "SBCode",
		label: "发票代码",
		columnwidth: 170,
	},
	{
		prop: "CheckWayName",
		label: "发票类型",
		columnwidth: 131,
	},
	{
		prop: "VouCode",
		label: "经销商出库单号",
		columnwidth: 125,
	},
	// {
	//   prop: "VouCode",
	//   label: "出库单号",
	//   columnwidth: 230,
	// },
	// {
	//   prop: "OuterCode",
	//   label: "外部订单号",
	//   columnwidth: 230,
	// },
	{
		prop: "Total",
		label: "发票金额",
		columnwidth: 92,
	},

	// {
	//   prop: "CheckerName",
	//   label: "发票标注人",
	//   columnwidth: 100,
	// },
	{
		prop: "CheckTime",
		label: "发票标注时间",
		columnwidth: 110,
	},
	{
		prop: "CheckedRemark",
		label: "发票标注内容",
		columnwidth: 306,
	},
	// {
	//   prop: "Check2Time",
	//   label: "二次校验时间",
	//   columnwidth: 101,
	// },
	{
		prop: "CheckerName",
		label: "标注人",
		columnwidth: 101,
	}, {
		prop: "InvoiceErrMessage",
		label: "发票校验结果",
		columnwidth: 100,
	},
	{
		prop: "CreateTime",
		label: "上传时间",
		columnwidth: 162,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 232,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 101,
	},
	{
		prop: "VerifierName",
		label: "审核人",
		columnwidth: 232,
	},
	{
		prop: "VerifyTime",
		label: "审核时间",
		columnwidth: 162,
	},
	{
		prop: "TechnicalOffices",
		label: "院区/科室",
		columnwidth: 150,
	},
];

export default headerDataTow;